import SiteLayout from "@/components/layouts/SiteLayout";
import CommonUtils from "@/utils/CommonUtils";

export default function PrivacyPolicy() {
  return (
    <SiteLayout
      title={"Post your ad | " + CommonUtils.appName}
      description="Post your ad"
    >
      <div className="container mx-auto space-y-4 mb-20">
        <h2 className="text-3xl">Post your add</h2>
        <p>
          To post your ad, please send your ad details, please click{" "}
          <a
            target="_new"
            href="https://wa.me/255621394783?text=I%20would%20like%20to%20post%20my%20ad"
            className="text-blue-500 underline"
          >
            here
          </a>{" "}
          to send your ad details to our WhatsApp number{" "}
          <a
            target="_new"
            href="https://wa.me/255621394783?text=I%20would%20like%20to%20post%20my%20ad"
          >
            (+255621394783)
          </a>{" "}
        </p>
      </div>
    </SiteLayout>
  );
}
